/**
 * Family device token storage.
 *
 * When a guardian links this browser as a "family device", the backend returns
 * an opaque token exactly once; it lives in localStorage under its own key,
 * SEPARATE from the auth session. It must survive student logout / profile
 * switches — clearing the auth session must NOT clear this token, so the
 * browser keeps showing the family profile picker.
 */

const FAMILY_DEVICE_TOKEN_KEY = 'ponder-family-device-token';

export function getFamilyDeviceToken(): string | null {
  try {
    return localStorage.getItem(FAMILY_DEVICE_TOKEN_KEY);
  } catch {
    // design-checks:failure-as-answer — storage the browser blocks holds no token.
    return null;
  }
}

export function setFamilyDeviceToken(token: string): void {
  localStorage.setItem(FAMILY_DEVICE_TOKEN_KEY, token);
}

/** Called when the backend reports the token invalid/revoked */
export function clearFamilyDeviceToken(): void {
  localStorage.removeItem(FAMILY_DEVICE_TOKEN_KEY);
}

export function hasFamilyDeviceToken(): boolean {
  return !!getFamilyDeviceToken();
}
